import 'reflect-metadata';
import {
  Expose,
  plainToInstance,
  instanceToPlain,
  Type,
} from 'class-transformer';

export class HomeRank {
  @Expose({ name: 'current_rank' })
  currentRank?: number;

  @Expose({ name: 'rank_achievements' })
  @Type(() => HomeAchievedRank)
  achievedRanks: HomeAchievedRank[];

  @Expose({ name: 'higher_ranks' })
  @Type(() => HomeNextRank)
  higherRanks: HomeNextRank[];

  @Expose({ name: 'criteria_achieved' })
  @Type(() => RankCriteriaAchieved)
  criteriaAchieved: RankCriteriaAchieved;

  constructor(
    currentRank: number | undefined,
    achievedRanks: HomeAchievedRank[],
    higherRanks: HomeNextRank[],
    criteriaAchieved: RankCriteriaAchieved
  ) {
    this.currentRank = currentRank;
    this.achievedRanks = achievedRanks;
    this.higherRanks = higherRanks;
    this.criteriaAchieved = criteriaAchieved;
  }

  static fromJson(json: Record<string, any>): HomeRank {
    return plainToInstance(HomeRank, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}

export class HomeAchievedRank {
  id: number;

  name: string;

  bonus: string;

  @Expose({ name: 'created_at' })
  @Type(() => Date)
  dateCreated: Date;

  constructor(id: number, name: string, bonus: string, dateCreated: Date) {
    this.id = id;
    this.name = name;
    this.bonus = bonus;
    this.dateCreated = dateCreated;
  }

  static fromJson(json: Record<string, any>): HomeAchievedRank {
    return plainToInstance(HomeAchievedRank, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}

export class HomeNextRank {
  id: number;

  name: string;

  bonus: string;

  @Expose({ name: 'is_higher_rank' })
  isHigherRank: boolean;

  @Expose({ name: 'downline_ranks' })
  downlineRanks: string;

  @Expose({ name: 'downline_count' })
  downlineCount: number;

  @Expose({ name: 'downline_sale' })
  downlineSale: string;

  constructor(
    id: number,
    name: string,
    bonus: string,
    isHigherRank: boolean,
    downlineRanks: string,
    downlineCount: number,
    downlineSale: string
  ) {
    this.id = id;
    this.name = name;
    this.bonus = bonus;
    this.isHigherRank = isHigherRank;
    this.downlineRanks = downlineRanks;
    this.downlineCount = downlineCount;
    this.downlineSale = downlineSale;
  }

  static fromJson(json: Record<string, any>): HomeNextRank {
    return plainToInstance(HomeNextRank, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}

export class RankCriteriaAchieved {
  @Expose({ name: 'downline_count' })
  downlineCount?: number;

  @Expose({ name: 'downline_sale' })
  downlineSale?: string;

  constructor(
    downlineCount: number | undefined,
    downlineSale: string | undefined
  ) {
    this.downlineCount = downlineCount;
    this.downlineSale = downlineSale;
  }

  static fromJson(json: Record<string, any>): RankCriteriaAchieved {
    return plainToInstance(RankCriteriaAchieved, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}
